'use es6';

import { combineReducers } from 'redux';
import Ads from './Ads';
import Attributes from './Attributes';
import Auth from './Auth';
import BlogUsageLimits from './BlogUsageLimits';
import Content from './Content';
import Domain from './Domain';
import Forms from './Forms';
import CmsUserSettings from './CmsUserSettings';
import ContentUsageLimits from './ContentUsageLimits';
import HubDbRows from './HubDbRows';
import HubDbTable from './HubDbTable';
import ListRegistrations from './ListRegistrations';
import Lists from './Lists';
import MAB from './MAB';
import MABEndTest from './MABEndTest';
import MABPastExperiments from './MABPastExperiments';
import ModalsDisplay from './ModalsDisplay';
import notifications from 'ReduxMessenger/reducers/Notifications';
import PerformanceDataCheck from './PerformanceDataCheck';
import Settings from './Settings';
import SmartContent from './SmartContent';
import SmartContentDataCheck from './SmartContentDataCheck';
import Stylesheets from './Stylesheets';
import Template from './Template';
import Variations from './Variations';
import VideoMap from './VideoMap';
import CrmObjects from './CrmObjects';
export default combineReducers({
  ads: Ads,
  attributes: Attributes,
  auth: Auth,
  blogUsageLimits: BlogUsageLimits,
  cmsUserSettings: CmsUserSettings,
  content: Content,
  contentUsageLimits: ContentUsageLimits,
  crmObjects: CrmObjects,
  domain: Domain,
  forms: Forms,
  hubDbRows: HubDbRows,
  hubDbTable: HubDbTable,
  listRegistrations: ListRegistrations,
  lists: Lists,
  mab: MAB,
  mabEndTest: MABEndTest,
  mabPastExperiments: MABPastExperiments,
  modalsDisplay: ModalsDisplay,
  notifications,
  performanceDataCheck: PerformanceDataCheck,
  settings: Settings,
  smartContent: SmartContent,
  smartContentDataCheck: SmartContentDataCheck,
  stylesheets: Stylesheets,
  template: Template,
  variations: Variations,
  videoMap: VideoMap
});